import apolloClient from '../../utils/apollo-client';
import { createEmployeeEmbeddedUrl as mutation } from '../graphql/settlement';

export default async function () {
  const response = await apolloClient().then((client) =>
    client.mutate({
      mutation
    })
  );
  return response.data.createEmployeeEmbeddedUrl.url;
}
